import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "onb-panel"
}
const _hoisted_2 = { class: "header onb-header-main" }
const _hoisted_3 = { class: "text-base font-medium" }
const _hoisted_4 = { class: "onb-header-actions" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "body" }
const _hoisted_8 = { class: "onb-title" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "text-base font-medium" }
const _hoisted_11 = { class: "onb-title-steps" }
const _hoisted_12 = { class: "onb-progress-row" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "onb-progress-badge" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "onb-progress-badge-complete" }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { key: 3 }
const _hoisted_19 = { class: "onb-steps flex flex-col gap-2.5 overflow-hidden" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  key: 0,
  class: "onb-step-icon"
}
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = {
  key: 1,
  class: "onb-step-icon"
}
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { key: 3 }
const _hoisted_27 = {
  class: "text-base onb-step-text text-extra-muted",
  style: {"text-decoration-line":"line-through"}
}
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "ml-auto onb-show-on-hover text-sm w-12 text-right" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "ml-auto onb-show-on-hover text-sm w-12 text-right" }
const _hoisted_34 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($setup.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createCommentVNode(" Header "),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.__("Getting Started")), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              onClick: $setup.toggleCollapse,
              innerHTML: $props.minimizeIcon
            }, null, 8 /* PROPS */, _hoisted_5),
            _createElementVNode("button", {
              onClick: $setup.close,
              innerHTML: $props.closeIcon
            }, null, 8 /* PROPS */, _hoisted_6)
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["onb-collapsible", $setup.collapsed ? 'onb-collapsible--collapsed' : 'onb-collapsible--expanded'])
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                class: "onb-title-icon",
                innerHTML: $props.headerIcon
              }, null, 8 /* PROPS */, _hoisted_9),
              _createElementVNode("div", _hoisted_10, _toDisplayString($props.title), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_11, _toDisplayString($setup.completedCount) + "/" + _toDisplayString($props.steps.length) + " " + _toDisplayString(_ctx.__("steps completed")), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_12, [
              ($setup.progress !== 100)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString($setup.progress) + "% " + _toDisplayString(_ctx.__("completed")), 1 /* TEXT */)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, _toDisplayString($setup.progress) + "% " + _toDisplayString(_ctx.__("completed")), 1 /* TEXT */)
                  ])),
              ($setup.skippAll)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("span", {
                      class: "onb-skip",
                      onClick: _cache[0] || (_cache[0] = $event => ($setup.resetAll($props.steps)))
                    }, _toDisplayString(_ctx.__("Reset All")), 1 /* TEXT */)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("span", {
                      class: "onb-skip",
                      onClick: _cache[1] || (_cache[1] = $event => ($setup.skipAll($props.steps)))
                    }, _toDisplayString(_ctx.__("Skip All")), 1 /* TEXT */)
                  ]))
            ]),
            _createCommentVNode(" Steps "),
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.steps, (step, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  style: {"width":"100%"},
                  key: i,
                  class: _normalizeClass({ is_complete: step.is_complete })
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["onb-group w-full step-title flex items-center", 
								step.is_complete
									? 'text-extra-muted onb-select-cursor'
									: 'text-ink-gray-8 onb-select-cursor'
							]),
                    style: {"align-items":"center"}
                  }, [
                    _createElementVNode("div", {
                      class: "onb-step-left",
                      onClick: $event => ($setup.handleAction(step))
                    }, [
                      (step.is_complete)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createElementVNode("div", { innerHTML: $props.completeChecklistIcon }, null, 8 /* PROPS */, _hoisted_22)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _createElementVNode("div", { innerHTML: $props.checklistIcon }, null, 8 /* PROPS */, _hoisted_24)
                          ])),
                      (!step.is_skipped)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["text-base onb-step-text", step.is_complete ? 'text-extra-muted' : ''])
                            }, _toDisplayString(_ctx.__(step.action_label)), 3 /* TEXT, CLASS */)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.__(step.action_label)), 1 /* TEXT */)
                          ]))
                    ], 8 /* PROPS */, _hoisted_20),
                    (!step.is_complete)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          (!step.is_skipped)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                _createElementVNode("div", _hoisted_30, [
                                  _createElementVNode("span", {
                                    style: {"font-size":"12px","vertical-align":"text-top","margin-right":"0px"},
                                    class: "text-ink-gray-7",
                                    onClick: $event => ($setup.markSkip(step))
                                  }, _toDisplayString(_ctx.__("Skip")), 9 /* TEXT, PROPS */, _hoisted_31)
                                ])
                              ]))
                            : _createCommentVNode("v-if", true),
                          (step.is_skipped)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("span", {
                                    style: {"font-size":"12px","vertical-align":"text-top","margin-right":"0px"},
                                    class: "text-ink-gray-7",
                                    onClick: $event => ($setup.markReset(step))
                                  }, _toDisplayString(_ctx.__("Reset")), 9 /* TEXT, PROPS */, _hoisted_34)
                                ])
                              ]))
                            : _createCommentVNode("v-if", true)
                        ]))
                      : _createCommentVNode("v-if", true)
                  ], 2 /* CLASS */)
                ], 2 /* CLASS */))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ], 2 /* CLASS */)
      ]))
    : _createCommentVNode("v-if", true)
}